// extracted by mini-css-extract-plugin
export default {"container":"EX-z","title":"FX-z","link":"GX-z"};